import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeNormCardReport } from './Pages/listing';

export const EmployeeNormCardReportRoutes = ({ match }) => (
   
    <Fragment>
        <Route exact path={`${match.path}`} component={EmployeeNormCardReport} />
    </Fragment>
   
    
)

